import React, { useState, useEffect } from 'react'
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
import Search from "../../components/ThirdPartyDashboard/Search";
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { facilityVerify , SubmitComment, ListComment} from "../../apis/General/web3/shared";
import "../../styles/ThirdParty/Verification.scss";
import { useSelector } from 'react-redux';
import { getThreeMonthUnverifiedAccumulationsForPlant, getIndividualEmissionsForCard,getThreeMonthUnverifiedAccumulationsAll ,getThreeMonthUnverifiedAccumulationCardsForPlant} from "../../instantiateTransaction/basicGreenProject";
import { toast } from 'react-toastify';
import {getUserDetails} from '../../apis/ThirdPartyDashboard/dashboard';
function Web3VerificationData() {
    const params = useParams();
    const { id } = useParams();
    const {plantId} = useParams()
    const {rangeStartDate} = useParams()
    const {rangeEndDate} = useParams()
    const {totalEd} = useParams()
    const {baseline} = useParams()
    const {totalC} = useParams()
    console.log("end",rangeEndDate)
    console.log("start",rangeStartDate) 
    console.log("id",id);
    const [plantData, setPlantData] = useState(null);
    const [unverifiedData, setUnverifiedData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pageSize, setPageSize] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [openCommentModal, setOpenCommentModal] = useState(false);
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [comment, setComment] = useState('');
    const [verificationLoading, setVerificationLoading] = useState(false);
    const [walletAddress, setWalletAddress] = useState(id);

    const recordsPerPage = 8;

// backend need to send frontend this vulue but they are busy with kr
    const plantAddress = ["GF-HP-2877835"||"GF-HP-8456281"];
    const createdAt = ["1732706085378"]
    const userId = "UN9ujbCjkMHfmgKWhM38maR4";
 

    // const rangeEndDate = params[2];
    // console.log("End and start date",{id}, rangeEndDate);


    const auth = useSelector((state) => state.auth);

    // Modal handlers
    const handleCloseCommentModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            setOpenCommentModal(false);
            setIsClosing(false);
        }, 300);
    };

    const handleCloseVerifyModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            setOpenVerifyModal(false);
            setIsClosing(false);
        }, 300);
    };

    const handleCommentSubmit = async () => {
        // Handle comment submission logic here
        try {
        console.log('Comment submitted:', comment);
        setComment('');
        const submitComment = await SubmitComment(comment,userId, auth?.token);
        console.log("Comment Submission Response:", submitComment);
        setOpenCommentModal(false);
   } catch (err) {
            console.error("Error verifying facility:", err);
            alert("Failed to verify facility. Please try again.");
        } finally {
            setVerificationLoading(false);
        }
        // Add your API call for comment submission here
    };

    const handleVerifyConfirm = async () => {
        try {
            setVerificationLoading(true);
            await facilityVerify(
                plantAddress,
                "green",
                "basic",
                auth?.token
            );
            toast.success("Facility verified successfully!");
            setOpenVerifyModal(false);
            // Refresh data after verification
            fetchAllUnverifiedAccumulations();
            if (id) {
                getThreeMonthUnverifiedAccumulationsForPlantData(id);
            }
        } catch (err) {
            console.error("Error verifying facility:", err);
            alert("Failed to verify facility. Please try again.");
        } finally {
            setVerificationLoading(false);
        }
    };

    const getThreeMonthUnverifiedAccumulationsForPlantData = async (address) => {
        try {
            setLoading(true);
            setError(null);
            const result = await getThreeMonthUnverifiedAccumulationCardsForPlant(address);
            console.log("Three Month Unverified Accumulations for Plant:", result);
            setPlantData(result);
        } catch (err) {
            console.error("Error fetching data for plant:", err);
            setError(err.message || "Failed to fetch plant data");
        } finally {
            setLoading(false);
        }
    }

    const fetchAllUnverifiedAccumulations = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const result = await getIndividualEmissionsForCard(plantId, rangeStartDate, rangeEndDate);
            console.log("All Unverified Data:", result);
            setWalletAddress(result?.plantAddress || id);
            
            setUnverifiedData(result);
        } catch (err) {
            console.error("Error fetching all unverified accumulations:", err);
            setError(err.message || "Failed to fetch unverified data");
        } finally {
            setLoading(false);
        }
    };

    // Transform the console data into table rows
    const transformDataToTableRows = () => {
        const rows = [];
        
        if (unverifiedData?.individualEmissions && Array.isArray(unverifiedData.individualEmissions)) {
            unverifiedData.individualEmissions.forEach((emission, index) => {
                // Create table row data from individual emission
                const rowData = {
                    id: index + 1,
                    date: emission.date || 'N/A',
                    projectEmission: `${emission.totalGHGEmission || '0.00'}tCO2e`,
                    baselineEmission: `${emission.quantifiedGHGEmissionsInBaselineScenario || '0.00'}tCO2e`,
                    energyConsumption: `${emission.energyConsumptionInKWh || '0.00'}kWh`,
                    emissionReduction: calculateEmissionReduction(emission),
                    plantAddress: unverifiedData.plantAddress,
                    facilityName: plantData?.facilityName || 'Unknown Facility'
                };
                
                rows.push(rowData);
            });
        }
        
        return rows;
    };

    // Calculate emission reduction
    const calculateEmissionReduction = (plantData) => {
        const baseline = parseFloat(plantData.quantifiedGHGEmissionsInBaselineScenario) || 0;
        const project = parseFloat(plantData.totalGHGEmission) || 0;
        
        if (baseline > project) {
            return `${(baseline - project).toFixed(4)}tCO2`;
        }
        return '0.0000tCO2';
    };

    // Pagination logic
    const allRows = transformDataToTableRows();
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = allRows.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(allRows.length / recordsPerPage);

    const handlePreviousPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    

    const handleRefresh = () => {
        fetchAllUnverifiedAccumulations();
        if (id) {
            getThreeMonthUnverifiedAccumulationsForPlantData(id);
        }
    };

       const getUserData = async () => {
       
        try {
            const userData = await getUserDetails(auth?.token, auth?.userInfo?.id);
            console.log("User Data for verifier:", userData);
            // You might want to set this data to state if you need to use it in your component
            // setUserData(userData);
        } catch (err) {
            console.error("Error fetching user data:", err);
        }
    };
     // useEffect hooks
    useEffect(() => {
        getUserData();
    }, [auth?.token, plantAddress]); // Added proper dependencies

    useEffect(() => {
        fetchAllUnverifiedAccumulations();
        if (id) {
            getThreeMonthUnverifiedAccumulationsForPlantData(id);
        } else {
            setError("No plant address provided");
            setLoading(false);
        }
    }, [id]);
    return (
        <div className="thirdparty_verification">
            <div className="sidebar_container">  
                <SideBar />
            </div>

            <div className="main">
                <Search />
                
                {loading && (
                    <div className="flex justify-center items-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#006633]"></div>
                        <span className="ml-2 text-gray-600">Loading plant data...</span>
                    </div>
                )}

                {error && (
                    <div className="border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                        Error: {error}
                    </div>
                )}

                {plantData && !loading && (
                    <div className="flex flex-col items-end p-0 gap-4 w-full max-w-[1155px] mx-auto">
                        {/* Action Buttons */} 
                        <div className="flex flex-row justify-end items-start p-0 gap-5 w-[333px] h-[59px]">
                            {/* Leave Comment Button */}
                            <button 
                                className="flex flex-row justify-center items-center p-2 gap-2 w-[167px] h-[59px] box-border border border-[#006633] rounded-lg hover:bg-gray-50 transition-colors"
                                onClick={() => setOpenCommentModal(true)}
                            >
                                <span className="w-[135px] h-6 font-inter font-semibold text-[16px] leading-6 text-center bg-gradient-to-r from-[#006633] to-[#00AED9] bg-clip-text text-transparent">
                                    Leave Comment
                                </span>
                            </button>

                            {/* Verify Button */}
                            <button 
                                className="flex flex-row justify-center items-center p-2 gap-3 w-[154px] h-[59px] bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity"
                                onClick={() => setOpenVerifyModal(true)}
                            >
                                <span className="w-[46px] h-6 font-inter font-semibold text-[16px] leading-6 text-white">
                                    Verify
                                </span>
                            </button>
                        </div>

                        {/* Plant Information Card */}
                        <div className="flex flex-row  p-15 gap-16 w-full h-[208px] mt-[60px] ">
                            <div className="flex flex-row items-start  gap-12 h-[144px] p-5">
                                {/* Organization & Date Info */}
                                <div className="flex flex-col items-start p-0 gap-4 h-[128px]">
                                    {/* Organization Name */}
                                    <div className="flex flex-row items-center p-0 gap-3 w-[265px] h-6 mb-5">
                                        <span className="max-w-[170px] h-6   text-[16px] leading-6 text-[#101828]">
                                            Organizational Name:
                                        </span>
                                        <span className="max-w-[170px] h-6  text-[16px] leading-6 text-[#101828]">
                                            {plantData.facilityName || ''}
                                        </span>
                                    </div>

                                    {/* Reporting Period */}
                                    <div className="flex flex-row  p-0 gap-3 w-[265px] h-6 mb-5">
                                        <span className="max-w-[170px] h-6  text-[16px] leading-6 text-[#101828] mr-10 ">
                                            Reporting period:
                                        </span>
                                        <span className="max-w-[170px] h-6  text-[16px] leading-6 text-[#101828]">
                                            {plantData.reportingPeriod || 'Quarterly'}
                                        </span>
                                    </div>

                                    {/* Date Range */}
                                    <div className="flex flex-row  p-0 gap-[134px] w-[265px] h-12 mb-5">
                                        <span className="max-w-[150px] h-6  text-[16px] text-[#101828]">
                                            Date:
                                        </span>
                                        <div className="w-[170px] h-3  text-[16px] leading-6 text-[#101828]">
                                            {unverifiedData.rangeStartDate || 'no date'} to {unverifiedData.rangeEndDate || 'date'}
                                        </div>
                                    </div>
                                </div>

                                {/* Emission Data */}
                                <div className="flex flex-col  p-0 gap-4 w-[360px] h-[144px]">
                                    {/* Total Project Emission */}
                                    <div className="flex flex-row  p-0 gap-6 w-[360px] h-6 mb-5">
                                        <span className="w-[219px] h-6  text-[16px] leading-6 text-[#101828]">
                                            Total Project emission data:
                                        </span>
                                        <span className="w-[125px] h-6  text-[16px] leading-6 text-[#101828]">
                                            {totalEd || ''}tCO2e
                                        </span>
                                    </div>

                                    {/* Total Baseline Emission */}
                                    <div className="flex flex-row  p-0 gap-4 w-[360px] h-6 mb-5">
                                        <span className="w-[219px] h-6 text-[16px] leading-6 text-[#101828]">
                                            Total Baseline emission data:
                                        </span>
                                        <span className="w-[94px] h-6  text-[16px] leading-6 text-[#101828]">
                                            {baseline || '0.00'}tCO2e
                                        </span>
                                    </div>

                                    {/* Total Energy Consumption */}
                                    <div className="flex flex-row  p-0 gap-8 w-[345px] h-6 mb-5">
                                        <span className="w-[219px] h-6  text-[16px] leading-6 text-[#101828] ">
                                            Total Energy consumption:
                                        </span>
                                        <span className="w-[110px] h-6  text-[16px] leading-6 text-[#101828]">
                                            {totalC || '0.00'}kWh
                                        </span>
                                    </div>

                                    {/* Facility Capacity */}
                                    <div className="flex flex-row  p-0 gap-[108px] w-[315px] h-6 mb-5">
                                        <span className="w-[219px] h-6  text-[16px] leading-6 text-[#101828]">
                                            Facility capacity:
                                        </span>
                                        <span className="w-[110px] h-6  text-[16px] leading-6 text-[#101828]">
                                            {plantData.facilityCapacity || '0.00'}tCO2e
                                        </span>
                                    </div>
                                </div>

                                {/* Document Links */}
                                <div className="flex flex-col  p-0 gap-4 w-[295px] h-[144px]">
                                    {/* Energy Consumption Data */}
                                    <div className="flex flex-row  p-0 gap-14 w-[295px] h-6 mb-5">
                                        <span className="w-[198px] h-6  text-[16px] leading-6 text-[#101828] ">
                                            Energy consumption data:
                                        </span>
                                        <button className="flex flex-row  p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                                            <Link to={`/iot/${plantAddress}/${createdAt}`} className="w-[39px] h-6 font-inter font-semibold text-[16px] leading-6 underline text-[#038B47]">
                                                View
                                            </Link>
                                        </button>
                                    </div>

                                    {/* KYC */}
                                    <div className="flex flex-row  p-0 gap-14 w-[295px] h-6 mb-5">
                                        <span className="w-[198px] h-6 font-inter font-normal text-[16px] leading-6 text-[#101828]">
                                            KYC:
                                        </span>
                                        <button className="flex flex-row  p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                                            <Link to={`/kcy/verifier/${plantAddress}`} className="w-[39px] h-6  text-[16px] font-semibold leading-6 underline text-[#038B47] mr-2">
                                                View
                                            </Link>
                                        </button>
                                    </div>

                                    {/* Quantification Methodology */}
                                    <div className="flex flex-row  p-0 gap-10 w-[295px] h-6 mb-5">
                                        <span className="w-[215px] h-6 text-[16px] leading-6 text-[#101828] ">
                                            Quantification methodology:
                                        </span>
                                        <button className="flex flex-row  p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                                            <span className="w-[39px] h-6  text-[16px] leading-6 underline font-semibold text-[#038B47] mr-2">
                                                View
                                            </span>
                                        </button>
                                    </div>

                                    {/* Project Design Document */}
                                    <div className="flex flex-row items-center p-0 gap-[61px] w-[295px] h-6">
                                        <span className="w-[194px] h-6 font-inter font-normal text-[16px] leading-6 text-[#101828]">
                                            Project design document:
                                        </span>
                                        <button className="flex flex-row justify-center items-center p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                                            <span className="w-[39px] h-6 font-inter font-semibold text-[16px]  leading-6 underline text-[#038B47] mr-12">
                                                View
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Emission Data Table */}
                        <div className="w-full mt-8">
                            {!loading && !error && allRows.length === 0 && (
                                <div className="text-center py-8 bg-gray-50 rounded-lg">
                                    <p className="text-gray-500 text-lg">No unverified plants found</p>
                                    <p className="text-gray-400 text-sm mt-2">All plants might be verified or there are no plants in the contracts</p>
                                </div>
                            )}

                            {!loading && !error && allRows.length > 0 && (
                                <div className="box-border w-full h-[582px] border border-[#E5E5E5] rounded-2xl">
                                    <div className="flex flex-col items-start p-0 w-full h-[582px]">
                                        {/* Table Header */}
                                        <div className="flex flex-col justify-center items-center p-0 w-full h-[52px] bg-[#2C9963] rounded-t-2xl">
                                            <div className="flex flex-row justify-center items-center p-0 w-full h-[48px]">
                                                {/* Date Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[130px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[52px] h-8 rounded-lg">
                                                        <span className="w-[32px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Date
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Project Emission Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[205px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[163px] h-8 rounded-lg">
                                                        <span className="w-[143px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Project emission data
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Baseline Emission Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[241px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[172px] h-8 rounded-lg">
                                                        <span className="w-[152px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Baseline emission data
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Energy Consumption Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[243px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[192px] h-8 rounded-lg">
                                                        <span className="w-[172px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Total energy consumption
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Emission Reduction Column */}
                                                <div className="flex flex-row justify-center items-center pr-2.5 w-[210px] h-[48px]">
                                                    <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[179px] h-8 rounded-lg">
                                                        <span className="w-[159px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                                                            Emission reduction data
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table Body */}
                                        <div className="flex flex-col items-start p-0 w-full h-[424px] overflow-y-auto">
                                            {currentRecords.map((record, index) => (
                                                <div key={record.id} className="flex flex-col justify-center items-center p-0 w-full h-[52px] bg-white border-b border-[#E5E5E5]">
                                                    <div className="flex flex-row justify-center items-center p-0 w-full h-[48px]">
                                                        {/* Date */}
                                                        <div className="flex flex-row justify-center items-center  w-[250px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5  h-8 rounded-lg">
                                                                <span className="w-full h-[18px]  font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.date}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Project Emission */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[205px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                                                <span className="w-[81px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.projectEmission}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Baseline Emission */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[241px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[92px] h-8 rounded-lg">
                                                                <span className="w-[72px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.baselineEmission}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Energy Consumption */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[243px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[122px] h-8 rounded-lg">
                                                                <span className="w-[102px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.energyConsumption}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* Emission Reduction */}
                                                        <div className="flex flex-row justify-center items-center pr-2.5 w-[210px] h-[48px]">
                                                            <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                                                <span className="w-[81px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                                                    {record.emissionReduction}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Pagination */}
                                        <div className="flex flex-row justify-end items-center px-6 py-3 w-full h-[62px] border-t border-[#E5E5E5]">
                                            <div className="flex flex-row items-start p-0 gap-4 w-[170px] h-[37px]">
                                                <button 
                                                    onClick={handlePreviousPage}
                                                    disabled={currentPage === 1}
                                                    className={`flex flex-row justify-center items-center p-2 gap-2 w-[90px] h-[37px] border border-[#E5E5E5] rounded-lg transition-colors ${
                                                        currentPage === 1 
                                                            ? 'bg-gray-100 cursor-not-allowed' 
                                                            : 'bg-white hover:bg-gray-50'
                                                    }`}
                                                >
                                                    <span className={`w-[58px] h-[21px] font-inter font-medium text-sm leading-[21px] ${
                                                        currentPage === 1 ? 'text-gray-400' : 'text-[#101828]'
                                                    }`}>
                                                        Previous
                                                    </span>
                                                </button>
                                                <button 
                                                    onClick={handleNextPage}
                                                    disabled={currentPage === totalPages}
                                                    className={`flex flex-row justify-center items-center p-2 gap-2 w-[64px] h-[37px] border border-[#E5E5E5] rounded-lg transition-colors ${
                                                        currentPage === totalPages 
                                                            ? 'bg-gray-100 cursor-not-allowed' 
                                                            : 'bg-white hover:bg-gray-50'
                                                    }`}
                                                >
                                                    <span className={`w-[32px] h-[21px] font-inter font-medium text-sm leading-[21px] ${
                                                        currentPage === totalPages ? 'text-gray-400' : 'text-[#101828]'
                                                    }`}>
                                                        Next
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Comment Modal */}
                {openCommentModal && (
                    <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
                        isClosing ? 'opacity-0' : 'opacity-100'
                    }`}>
                        <div className={`relative w-[600px] h-[584px] bg-white rounded-2xl transform transition-transform duration-300 ${
                            isClosing ? 'scale-95' : 'scale-100'
                        }`}>
                            
                            {/* Back Button */}
                            <div className="absolute left-6 top-9">
                                <div 
                                    className="flex flex-row items-center gap-0.5 cursor-pointer"
                                    onClick={handleCloseCommentModal}
                                >
                                    {/* Back Arrow Icon */}
                                    <div className="w-6 h-6">
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z"
                                                fill="#000000"
                                            />
                                            <path
                                                d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z"
                                                fill="#000000"
                                            />
                                        </svg>
                                    </div>
                                    {/* Back Text */}
                                    {/* <span className="font-medium text-xs leading-[15px] text-[#2C2C2C]">
                                        Back
                                    </span> */}
                                </div>
                            </div>

                            {/* Title */}
                            <div className="absolute left-1/2 top-8 transform -translate-x-1/2">
                                <h2 className="font-medium text-2xl leading-9 text-[#101828] text-center">
                                    Leave Comment
                                </h2>
                            </div>

                            {/* Content Area */}
                            <div className="absolute left-6 top-[100px] w-[552px] h-[452px] flex flex-col gap-8">
                                
                                {/* Comment Section */}
                                <div className="flex flex-col gap-8 w-full h-[364px]">
                                    <div className="flex flex-col gap-3 w-full h-full">
                                        {/* Comment Label */}
                                        <label className="font-semibold text-[16px] leading-6 text-[#101828]">
                                            Comment
                                        </label>
                                        
                                        {/* Textarea */}
                                        <div className="flex flex-row items-start p-5 gap-2.5 w-full h-[328px] border border-[#667185] border-opacity-50 rounded-lg focus-within:border-[#038B47] focus-within:border-2">
                                            <textarea
                                                value={comment}
                                                onChange={(e) => setComment(e.target.value)}
                                                className="w-full h-full resize-none outline-none font-normal text-[16px] leading-[21px] text-[#101828] placeholder-[#667185]"
                                                placeholder="Enter your comment here..."
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <button 
                                    className={`flex flex-row justify-center items-center py-2 px-4 gap-3 w-full h-14 rounded-lg ${
                                        comment.trim() 
                                            ? 'bg-gradient-to-r from-[#038B47] to-[#00AED9] cursor-pointer hover:opacity-90'
                                            : 'bg-gray-300 cursor-not-allowed'
                                    }`}
                                    onClick={handleCommentSubmit}
                                    disabled={!comment.trim()}
                                >
                                    <span className="font-semibold text-base leading-6 text-white">
                                        Submit Comment
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Verification Confirmation Modal */}
                {openVerifyModal && (
                    <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${
                        isClosing ? 'opacity-0' : 'opacity-100'
                    }`}>
                        <div className={`relative w-[600px] h-[338px] bg-white rounded-2xl transform transition-transform duration-300 ${
                            isClosing ? 'scale-95' : 'scale-100'
                        }`}>
                            
                            {/* Close Button */}
                            <div className="absolute right-6 top-6 ">
                                <button 
                                    onClick={handleCloseVerifyModal}
                                    className="w-8 h-8 cursor-pointer hover:bg-gray-100 rounded transition-colors flex items-center justify-center"
                                    disabled={verificationLoading}
                                >
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.899 1.49906C15.299 1.64906 17.549 2.84906 19.199 4.49906C21.149 6.59906 22.199 9.14906 22.199 12.1491C22.199 14.5491 21.299 16.7991 19.799 18.7491C18.299 20.5491 16.199 21.8991 13.799 22.3491C11.399 22.7991 8.99896 22.4991 6.89896 21.2991C4.79896 20.0991 3.14896 18.2991 2.24896 16.0491C1.34896 13.7991 1.19896 11.2491 1.94896 8.99906C2.69896 6.59906 4.04896 4.64906 6.14896 3.29906C8.09896 1.94906 10.499 1.34906 12.899 1.49906ZM13.649 20.8491C15.599 20.3991 17.399 19.3491 18.749 17.6991C19.949 16.0491 20.699 14.0991 20.549 11.9991C20.549 9.59906 19.649 7.19906 17.999 5.54906C16.499 4.04906 14.699 3.14906 12.599 2.99906C10.649 2.84906 8.54896 3.29906 6.89896 4.49906C5.24896 5.69906 4.04896 7.34906 3.44896 9.44906C2.84896 11.3991 2.84896 13.4991 3.74896 15.4491C4.64896 17.3991 5.99896 18.8991 7.79896 19.9491C9.59896 20.9991 11.699 21.2991 13.649 20.8491ZM11.849 11.2491L15.449 7.49906L16.499 8.54906L12.899 12.2991L16.499 16.0491L15.449 17.0991L11.849 13.3491L8.24896 17.0991L7.19896 16.0491L10.799 12.2991L7.19896 8.54906L8.24896 7.49906L11.849 11.2491Z" fill="#667185"/>
</svg>

                                </button>
                            </div>

                            {/* Content Area */}
                            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[450px] h-[212px] flex flex-col items-center gap-8">
                                
                                {/* Text Content */}
                                <div className="flex flex-col items-center gap-4 w-[428px] h-[124px]">
                                    {/* Title */}
                                    <h2 className="font-semibold text-[24px] leading-9 text-[#101828] text-center mb-5">
                                        Confirm Verification
                                    </h2>
                                    
                                    {/* Description */}
                                    <p className="font-normal text-[16px] leading-6 text-[#667185] text-center w-full">
                                        By proceeding, you affirm that all data and information meet the required standard, and all procedures are standard throughout the process.
                                    </p>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-row items-center justify-center gap-6 w-[600px] h-14">
                                    {/* Cancel Button */}
                                    <button 
                                        className="flex flex-row justify-center items-center py-2 px-4 gap-2 w-[199px] h-[56px] border border-[#667185] rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={handleCloseVerifyModal}
                                        disabled={verificationLoading}
                                    >
                                        <span className="font-semibold text-[16px] leading-6 text-[#667185]">
                                            Cancel
                                        </span>
                                    </button>

                                    {/* Confirm Button */}
                                    <button 
                                        className="flex flex-row justify-center items-center py-2 px-4 gap-2 w-[227px] h-[56px] bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={handleVerifyConfirm}
                                        disabled={verificationLoading}
                                    >
                                        {verificationLoading ? (
                                            <div className="flex items-center gap-2">
                                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                                <span className="font-semibold text-[16px] leading-6 text-white">
                                                    Verifying...
                                                </span>
                                            </div>
                                        ) : (
                                            <span className="font-semibold text-[16px] leading-6 text-white">
                                                Confirm Verification
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Web3VerificationData;